module.exports = __webpack_public_path__ + "static/media/sendBack.a3a4c749.svg";